// 圆形加号——主流程
const MainRoutes = Array.from({ length: 15 }, (_, i) => ({
  path: `icon/service/index${i + 1}`,
  name: `icon/serviceIndex${i + 1}`,
  component: () => import(`@/views/recognize/icon/service/index${i + 1}.vue`)
}))



export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 圆形加号——主流程，开始
    ...MainRoutes,
  ],
};
